import { injectReducer } from '../../store/reducers';

export const BidRoute = store => (
  {
    path: 'bid',
    /*  Async getComponent is only invoked when route matches   */
    getComponent(nextState, cb) {
      const Booking = require('./containers/BookingsContainer').default; // eslint-disable-line global-require
      const reducer = require('./modules/booking').default; // eslint-disable-line global-require

      injectReducer(store, { key: 'booking', reducer });
      /*  Return getComponent   */
      cb(null, Booking);
    },

    childRoutes: [
      {
        path: ':id(/:detail)',
        getComponent(nextState, cb) {
          const BookingDetailContainer = require('./containers/BookingDetailContainer').default; // eslint-disable-line global-require
          const reducer = require('./modules/booking').default; // eslint-disable-line global-require
          injectReducer(store, { key: 'booking', reducer });

          cb(null, BookingDetailContainer);
        },
      },
    ],
  }
);


export default store => (
  {
    path: 'booking',
    /*  Async getComponent is only invoked when route matches   */
    getComponent(nextState, cb) {
      const Booking = require('./containers/BookingsContainer').default; // eslint-disable-line global-require
      const reducer = require('./modules/booking').default; // eslint-disable-line global-require

      injectReducer(store, { key: 'booking', reducer });
      /*  Return getComponent   */
      cb(null, Booking);
    },

    childRoutes: [
      {
        path: ':id(/:detail)',
        getComponent(nextState, cb) {
          const BookingDetailContainer = require('./containers/BookingDetailContainer').default; // eslint-disable-line global-require
          const reducer = require('./modules/booking').default; // eslint-disable-line global-require
          injectReducer(store, { key: 'booking', reducer });

          cb(null, BookingDetailContainer);
        },
      },
    ],
  }
);



// WEBPACK FOOTER //
// src/routes/booking/index.js